import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { SkyLightStateless } from 'react-skylight';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Field } from 'redux-form';
import { Grid, Button, ButtonToolbar, Row, Col, Panel, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import ConfirmActionModal from '../Common/confirmActionModal';
import { DatePicker } from '../Common/datePicker';
import Spinner from '../Widgets/spinner';
import FilterByStart from '../Common/filterByStart';
import checkPermission from '../Common/permissions';
import { RowRenderer } from '../Common/rowRenderer';
import { voidWorkingOrder } from '../../actions/inventories_actions';

import { ROOT_URL } from '../../actions/root_url';

const contextTypes = {
  router: React.PropTypes.object,
};

const renderProductRadios = props => (
  <div className="form-group">
    <label className="col-md-3 filter-title">
      <Translate value="product" />:
    </label>
    <label className="col-md-3">
      <input
        {...props.input}
        type="radio"
        value="Piece"
        checked={props.input.value === 'Piece'}
      />
      <Translate value="piece" />
    </label>
    <label className="col-md-3">
      <input
        {...props.input}
        type="radio"
        value="Package"
        checked={props.input.value === 'Package'}
      />
      <Translate value="package" />
    </label>
    <label className="col-md-3">
      <input
        {...props.input}
        type="radio"
        value="All"
        checked={props.input.value === 'All'}
      />
      <Translate value="all" />
    </label>
  </div>
);

const renderInventoryRadios = props => (
  <div className="form-group">
    <label className="col-md-3 filter-title">
      <Translate value="inventory" />:
    </label>
    <label className="col-md-4">
      <input
        {...props.input}
        type="radio"
        value="Low"
        checked={props.input.value === 'Low'}
      />
      <Translate value="low_stock" />
    </label>
    <label className="col-md-4">
      <input
        {...props.input}
        type="radio"
        value="Negative"
        checked={props.input.value === 'Negative'}
      />
      <Translate value="negative" />
    </label>
  </div>
);

class ProductConvertReport extends Component {
  constructor() {
    super();
    this.state = {
      product: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      workingOrder: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        selectedRows: [],
      },
      checkAuthorizeOpen: false,
      effectDate: undefined,
      isLoadingVoid: false,
    };
    this.fetchRelatedProducts = this.fetchRelatedProducts.bind(this);
    this.fetchLowInventories = this.fetchLowInventories.bind(this);
  }

  componentWillMount() {
    this.props.fetchLowInventories('Piece', 'Low');
    this.props.setDefaultOfForm('PackageSize', 'Piece', 'productConvertReport');
    this.props.setDefaultOfForm('Stock', 'Low', 'productConvertReport');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
      this.closeCheckAuthorize();
      this.handleVoidWorkingOrder();
    }

    if (nextProps.lowInventories && nextProps.lowInventories !== this.props.lowInventories) {
      const product = { ...this.state.product, rows: nextProps.lowInventories.ProductList };
      const workingOrder = { ...this.state.workingOrder, rows: nextProps.lowInventories.WorkingOrder };
      this.setState({ product, workingOrder });
    }

    if (nextProps.EffectDate && nextProps.EffectDate !== this.props.EffectDate) {
      const date = new Date(nextProps.EffectDate);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      if (month < 10) {
        month = `0${month}`;
      }
      if (day < 10) {
        day = `0${day}`;
      }
      this.setState({ effectDate: `${year}-${month}-${day}` }, () => {
        this.props.fetchWorkingOrders(this.state.effectDate);
      });
    }

    if (nextProps.workingOrders && nextProps.workingOrders !== this.props.workingOrders) {
      const workingOrder = { ...this.state.workingOrder, rows: nextProps.workingOrders.WorkingOrder };
      this.setState({ workingOrder });
    }
  }

  openCheckAuthorize = () => {
    this.props.clearCheckPassword();
    this.setState({ checkAuthorizeOpen: true });
  }

  closeCheckAuthorize = () => {
    this.setState({ checkAuthorizeOpen: false });
  }

  checkAuthorize = (password) => {
    this.props.checkPassword(password);
  }

  handleVoidWorkingOrder = () => {
    const { effectDate } = this.state;
    const { selectedRows } = this.state.workingOrder;
    const handleSuccess = () => {
      this.setState({ isLoadingVoid: false }, () => {
        this.props.fetchLowInventories('Piece', 'Low');
      });
    };

    const handleFailure = (err) => {
      this.setState({ isLoadingVoid: false });
      alert(JSON.stringify(err.data));
    };

    if (selectedRows && selectedRows.length === 1) {
      this.setState({ isLoadingVoid: true }, () => {
        voidWorkingOrder(selectedRows[0], handleSuccess, handleFailure);
      });
    }
  }

  shouldVoidDisable() {
    const { isLoadingVoid } = this.state;
    const { selectedRows } = this.state.workingOrder;
    return (isLoadingVoid
      || (selectedRows
      && (selectedRows.length === 0 || selectedRows.length > 1))
    );
  }

  fetchLowInventories() {
    this.props.fetchLowInventories(this.props.PackageSize, this.props.Stock);
  }

  fetchRelatedProducts(row) {
    this.props.fetchRelatedProducts(row.ProductNum);
    this.context.router.push('/productConvertReport/new');
  }

  renderProductTable() {
    if (this.props.lowInventoriesIsLoading && !this.props.lowInventoriesError) {
      return (
        <div id="spinner">
          <Spinner />
        </div>
      );
    } else if (this.props.lowInventoriesError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.lowInventoriesError)}</div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid

    const getRows = () => Data.Selectors.getRows(this.state.product);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({ Idx: rowIdx }, rows[rowIdx]);
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
      const product = Object.assign({}, this.state.product, { sortColumn, sortDirection });
      this.setState({ product });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.product.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const product = { ...this.state.product, filters: newFilters };
      this.setState({ product });
    };

    const onClearFilters = () => {
      const product = { ...this.state.product, filters: {} };
      this.setState({ product });
    };

    const columns = [
      {
        key: 'ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        filterRenderer: FilterByStart,
      },
      {
        key: 'RefNum',
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        filterRenderer: FilterByStart,
      },
      {
        key: 'Name',
        name: <Translate value="prod_name" />,
        resizable: true,
        sortable: true,
        width: 250,
        filterable: true,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
      },
      {
        key: 'MinStockRange',
        name: <Translate value="min_qty" />,
        resizable: true,
        sortable: true,
        width: 60,
        filterable: true,
      },
      {
        key: 'InStock',
        name: <Translate value="inventory" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      },
      // {
      //   key: 'Action',
      //   name: <Translate value="action" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 70,
      //   editable: true,
      //   filterable: true,
      // },
      // {
      //   key: 'UpdateQuantity',
      //   name: <Translate value="update_qty" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 70,
      //   editable: true,
      //   filterable: true,
      // },
    ];

    return (
      <Row>
        <Col sm={12}>
          <div id="ProductConvert-dataGrid1">
            <ReactDataGrid
              rowRenderer={<RowRenderer onDoubleClick={this.fetchRelatedProducts} />}
              enableCellSelect
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter />}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              columns={columns}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={610}
              rowGetter={rowGetter}
              rowsCount={getSize()}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderWorkingOrderTable() {
    if (this.props.lowInventoriesIsLoading && !this.props.lowInventoriesError) {
      return (
        <div id="spinner">
          <Spinner />
        </div>
      );
    } else if (this.props.lowInventoriesError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.lowInventoriesIsLoading)}</div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid

    const getRows = () => Data.Selectors.getRows(this.state.workingOrder);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({ Idx: rowIdx }, rows[rowIdx]);
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
      const workingOrder = Object.assign({}, this.state.workingOrder, { sortColumn, sortDirection });
      this.setState({ workingOrder });
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      const selectedRows = [...this.state.workingOrder.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
        selectedRows.push(r.row.WarehouseConvert_id);
      });
      const workingOrder = { ...this.state.workingOrder, rows: newRows, selectedRows };
      this.setState({ workingOrder });
    };

    const onRowsDeselected = (rows) => {
      const newRows = getRows();
      const selectedRows = [];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      newRows.map((r) => {
        if (r.isSelected) { selectedRows.push(r.WarehouseConvert_id); }
      });
      const workingOrder = { ...this.state.workingOrder, rows: newRows, selectedRows };
      this.setState({ workingOrder });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.workingOrder.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const workingOrder = { ...this.state.workingOrder, filters: newFilters };
      this.setState({ workingOrder });
    };

    const onClearFilters = () => {
      const workingOrder = { ...this.state.workingOrder, filters: {} };
      this.setState({ workingOrder });
    };

    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = new Date(this.props.value);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    // Column difinition

    const columns = [
      {
        key: 'order_num',
        name: <Translate value="order_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      },
      {
        key: 'CreateTime',
        name: <Translate value="effect_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 85,
      },
      // {
      //   key: 'From',
      //   name: <Translate value="from" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 55,
      // },
      {
        key: 'To',
        name: <Translate value="qty" />,
        resizable: true,
        sortable: true,
        width: 55,
      },
      // {
      //   key: 'ConvertStatus',
      //   name: <Translate value="status" />,
      //   resizable: true,
      //   sortable: true,
      //   filterable: true,
      //   width: 60,
      // },
    ];

    return (
      <Row>
        <Col sm={12}>
          <div id="ProductConvert-dataGrid2">
            <ReactDataGrid
              rowRenderer={<RowRenderer onDoubleClick={this.fetchRelatedProducts} />}
              enableCellSelect
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter />}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              columns={columns}
              rowHeight={25}
              minHeight={610}
              headerRowHeight={45}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowSelection={{
                showCheckbox: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected',
                },
              }}
            />
          </div>
        </Col>
      </Row>
    );
  }
  render() {
    const createDialogStyle = {
      width: '550px',
      height: '300px',
      marginLeft: '-15%',
    };
    const {
      selectedRows: workingOrders,
    } = this.state.workingOrder;

    let printWorkingOrderUrl = `${ROOT_URL}v1/warehouse/workingorder/print?`;
    workingOrders.forEach((r) => {
      printWorkingOrderUrl = `${printWorkingOrderUrl}pk=${r}&`;
    });
    printWorkingOrderUrl = `${printWorkingOrderUrl}Bearer=${localStorage.getItem('token')}`;
    const printLowInventoryUrl = `${ROOT_URL}v1/warehouse/lowinventory/print?Bearer=${localStorage.getItem('token')}`;
    const excelLowInventoryUrl = `${ROOT_URL}v1/warehouse/lowinventory/excel?Bearer=${localStorage.getItem('token')}`;

    const shouldPrintWorkingOrderDisable = workingOrders.length < 1;
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="warehouse_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="product_convert" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <ButtonToolbar>
          <Button bsStyle="primary" href={printLowInventoryUrl}>
            <em className="fa fa-print" /><Translate value="print" />
          </Button>
          <Button bsStyle="success" href={excelLowInventoryUrl}>
            <em className="fa fa-download" /><Translate value="excel" />
          </Button>
        </ButtonToolbar>
        <Grid id="product-convert">
          {/* <h1><Translate value="product_convert_page" /></h1> */}
          <Row>
            <Col md={8}>
              <Row>
                <Col md={12}><h2><Translate value="product_list" /></h2></Col>
              </Row>
              <Panel id="product-list">
                <Row id="product-and-inventory-filters">
                  <Col md={5}>
                    <Field name="PackageSize" component={renderProductRadios} />
                  </Col>
                  {/* <Col md={5}>
                    <Field name="Stock" component={renderInventoryRadios} />
                  </Col> */}
                  <Button
                    bsStyle="primary"
                    className="mr-md pull-right"
                    onClick={this.fetchLowInventories}
                    disabled={!checkPermission('add_product_convert')}
                  >
                    <Translate value="submit" />
                  </Button>
                </Row>
                { this.renderProductTable() }
              </Panel>
            </Col>
            <Col md={4}>
              <Row>
                <Col md={12}><h2><Translate value="working_order" /></h2></Col>
              </Row>
              <Panel id="working-order">
                <Row className="print-button">
                  <Col md={4}>
                    <Field name="EffectDate" component={DatePicker} />
                  </Col>
                  <Col md={8}>
                    <ButtonToolbar className="mr-md">
                      <Button
                        bsStyle="danger"
                        disabled={this.shouldVoidDisable()}
                        onClick={() => this.openCheckAuthorize()}
                      >
                        <em className="fa fa-trash" /><Translate value="void" />
                      </Button>
                      <Button
                        bsStyle="primary"
                        href={printWorkingOrderUrl}
                        disabled={shouldPrintWorkingOrderDisable}
                      >
                        <em className="fa fa-print" /><Translate value="print" />
                      </Button>
                    </ButtonToolbar>
                  </Col>
                </Row>
                { this.renderWorkingOrderTable() }
              </Panel>
            </Col>
          </Row>
        </Grid>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.checkAuthorizeOpen}
          onCloseClicked={this.closeCheckAuthorize}
        >
          <ConfirmActionModal
            case="confirmPassword"
            closeC={this.checkAuthorize}
            checkPasswordFailure={this.props.checkPasswordFailure}
          />
        </SkyLightStateless>
      </ContentWrapper>
    );
  }
}

ProductConvertReport.contextTypes = contextTypes;

export default ProductConvertReport;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/productConvert.jsx